import React, { useEffect, useState } from "react";
import "./translation.css";
import { createLanguageAPI, getTranslationsAPI } from "../../api/auth";
import { words } from "./utils";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CustomButon from "../../component/Button";
import MiniDrawer from "../../component/Layout1";
import CustomDialog from "../../component/dailog/dailog";

const Translation = () => {
  const [translation, setTranslation] = useState({});
  const [formValues, setFormValues] = useState({
    key: "",
    english: "",
    hindi: "",
  });

  const getTranslatedData = async () => {
    const res = await getTranslationsAPI();
    if (res.remote === "success") {
      const data = res.data.translations;
      const trans = { ...translation };

      for (let i = 0; i < data.length; i++) {
        trans[data[i].original] = {
          en: data[i].en,
          hi: data[i].hi,
        };
      }
      setTranslation(trans);
    } else {
      console.log("API Error:", res);
    }
  };
  useEffect(() => {
    getTranslatedData();
  }, []);

  const handleSubmit = async (original) => {
    if (translation[original]) {
      if (translation[original].en && translation[original].hi) {
        const res = await createLanguageAPI({
          original,
          en: translation[original].en,
          hi: translation[original].hi,
        });
        // if (res.remote === "success") {
        // } else {
        //   console.log("API Error:", res);
        // }
      }
    }
  };

  const [openAddForm, setOpenAddForm] = useState(false);

  const handleOpenAddForm = () => setOpenAddForm(true);
  const handleCloseAddForm = () => setOpenAddForm(false);
  const handleSaveAddForm = async () => {
    const res = await createLanguageAPI({
      original: formValues.key,
      en: formValues.english,
      hi: formValues.hindi,
    });
    if (res.remote === "success") {
      alert("success");
    } else {
      console.log("API Error:", res);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  return (
    <MiniDrawer>
      <Box>
        <Box
          sx={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h4" sx={{ fontSize: "30px", fontWeight: "500" }}>
            Translation
          </Typography>
          <CustomButon variant="contained" onClick={() => setOpenAddForm(true)}>
            Add
          </CustomButon>
        </Box>
        <Box className="FormBox" mb={3}>
          <TableContainer component={Paper}>
            <Table className="translation-table">
              <TableHead>
                <TableRow>
                  <th>Original Text</th>
                  <th>English</th>
                  <th>Hindi</th>
                  <th>Actions</th>
                </TableRow>
              </TableHead>
              <TableBody>
                {words.map((word) => (
                  <TableRow key={word}>
                    <td>{word}</td>
                    <td>
                      <input
                        type="text"
                        placeholder="English"
                        value={translation[word]?.en}
                        onChange={(e) =>
                          setTranslation((prevState) => ({
                            ...prevState,
                            [word]: {
                              ...(prevState[word] || {}),
                              en: e.target.value,
                            },
                          }))
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        placeholder="Hindi"
                        value={translation[word]?.hi}
                        onChange={(e) =>
                          setTranslation((prevState) => ({
                            ...prevState,
                            [word]: {
                              ...(prevState[word] || {}),
                              hi: e.target.value,
                            },
                          }))
                        }
                      />
                    </td>
                    <td>
                      <CustomButon
                        variant="contained"
                        sx={{
                          background: "#1ACC43",
                          "&:hover": {
                            backgroundColor: "#1ACC43",
                          },
                        }}
                        onClick={() => handleSubmit(word)}
                      >
                        Submit
                      </CustomButon>

                      <CustomButon
                        variant="contained"
                        sx={{
                          background: "#1ACC43",
                          "&:hover": {
                            backgroundColor: "#1ACC43",
                          },
                        }}
                        // onClick={() => handleSubmit(word)}
                      >
                        Edit
                      </CustomButon>
                    </td>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      <CustomDialog
        open={openAddForm}
        onClose={handleCloseAddForm}
        title="Add Translation"
        onSave={handleSaveAddForm}
      >
        <form>
          <Grid
            container
            spacing={2}
            sx={{
              "& input": {
                width: "100%",
                padding: "10px ",
                borderRadius: "5px",
              },
            }}
          >
            <Grid item md={6}>
              {" "}
              <input
                name="key"
                type="text"
                placeholder="Key"
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item md={6}>
              {" "}
              <input
                type="text"
                placeholder="English"
                name="english"
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item md={6}>
              {" "}
              <input
                type="text"
                placeholder="Hindi"
                name="hindi"
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </form>
      </CustomDialog>
    </MiniDrawer>
  );
};

export default Translation;
